export default __webpack_public_path__ + "1554936f138099c7050069c875d761c7.png";